import api from '../../../api'
import { executeResponseError } from '../../../helpers'
import { setNewDataPositions } from '../positions/actions'
import { setSidebarIsOpen } from '../sidebar/actions'
// import { setUser } from '../user/actions'


export const ASSET_ALL_GET = 'ASSET_ALL_GET'
export const ASSET_SO_ID_LIST_SET = 'ASSET_SO_ID_LIST_SET'
export const ASSET_SET_SELECTED = 'ASSET_SET_SELECTED'
export const ASSETS_SET_CURRENT_TAB = 'ASSETS_SET_CURRENT_TAB'
export const ASSETS_CURRENT_LIST_SET = 'ASSETS_CURRENT_LIST_SET'
export const ASSETS_UPDATE_BY_SOCKETS = 'ASSETS_UPDATE_BY_SOCKETS'
export const ASSET_SET_FAVORITE = 'ASSET_SET_FAVORITE'
export const ASSET_SET_INFO = 'ASSET_SET_INFO'
export const LOT_SIZES_GET = 'LOT_SIZES_GET'
export const TRADE_SIZES_GET = 'TRADE_SIZES_GET'
export const ASSET_SET_SEARCH = 'ASSET_SET_SEARCH'
export const ASSET_SET_SINGLE = 'ASSET_SET_SINGLE'
export const ASSET_TRADING_HOURS_GET = 'ASSET_TRADING_HOURS_GET'
export const ASSET_MUTED_SET = 'ASSET_MUTED_SET'
export const ASSET_ONLY_FAVORITE_SET = 'ASSET_ONLY_FAVORITE_SET'
export const LATEST_RATES_ITEM_SET = 'LATEST_RATES_ITEM_SET'
export const UPDATE_TRADE_LOT_SIZES = 'UPDATE_TRADE_LOT_SIZES'
export const getAssetsData = (classAssetsTypes, accessToken) => {
	return async dispatch => {
		try {
			const res = await api.assets.getAssets(classAssetsTypes, accessToken)
			if (res?.data?.entities) {
				dispatch({
					payload: res.data.entities,
					type: ASSET_ALL_GET
				})
				dispatch(refreshAssetData(res.data.entities))
			}
			return res.data.entities
		} catch (e) {
			const error = executeResponseError(e, 'Getting assets error')
			throw new Error(error || '')
		}
	}
}

export const setOnlyFavorite = (bool) => {
	return {
		payload: bool,
		type: ASSET_ONLY_FAVORITE_SET
	}
}

export const getTradingHoursData = () => {
	return async dispatch => {
		try {
			const res = await api.assets.getTradingHours()
			if (res.data) {
				dispatch({
					payload: res.data,
					type: ASSET_TRADING_HOURS_GET
				})
			}
		} catch (e) {
			const error = executeResponseError(e, 'Getting trading hours data error')
			throw new Error(error || '')
		}
	}
}

export const refreshAssetData = (assets) => {
	let result = []
	assets.forEach(asset => {
		result.push(asset.soId)
	})
	return async (dispatch, getState) => {
		const pricerLink = getState().appReducer.user?.userJson?.platform?.pricer?.link
		if(!pricerLink) return
		try {
			const res = await api.assets.refreshAsset(pricerLink + '/rest/rates/arr', result)
			if (res.data) {
				dispatch({
					payload: res.data,
					type: ASSET_MUTED_SET
				})
			}
			return res.data
		} catch (e) {
			const error = executeResponseError(e, 'Refresh assets error')
			throw new Error(error || '')
		}
	}
}

export const setFavoriteAsset = (data, token, body) => {
	return async dispatch => {
		try {
			const res = await api.assets.setFavorite(body, token)
			if (res.status === 200) {
				dispatch({
					payload: data,
					type: ASSET_SET_FAVORITE
				})
			}
			return res
		} catch (e) {
			const error = executeResponseError(e, 'Set favorite asset error')
			throw new Error(error || '')
		}
	}
}

export const setSelectedAsset = (data, assetName, sidebarType) => {
	return dispatch => {
		dispatch({
			payload: data,
			type: ASSET_SET_SELECTED
		})
		if (sidebarType) dispatch(setSidebarIsOpen(true, sidebarType, assetName))
	}
}

export const setCurrentTab = (tab) => {
	return dispatch => {
		dispatch({
			payload: tab,
			type: ASSETS_SET_CURRENT_TAB
		})
		dispatch(setCurrentAssetList(tab))
		dispatch(setCurrentSoIdList(tab))
	}
}

export const setCurrentSoIdList = (tab) => {
	return {
		payload: tab,
		type: ASSET_SO_ID_LIST_SET
	}
}

export const setCurrentAssetList = (tab) => {
	return {
		payload: tab,
		type: ASSETS_CURRENT_LIST_SET
	}
}

export const wsUpdateAssets = (data, alert, t) => {

	return (dispatch, getState) => {
		const latestRatesBidAsk = getState().appReducer.assets?.latestRatesBidAsk
		const riskData = getState().appReducer.user?.riskData
		let newDataBidAsk = {}
		let newDataRates = {}
		let key
		for (key in data) {
			let updateData = data[key]
			let quoteAssetClass = updateData['assetClass']
			let assetClassRiskName = riskData['spread_' + quoteAssetClass]
			let fallback = false
			if (updateData === undefined ||
				updateData[quoteAssetClass] === undefined ||
				updateData[quoteAssetClass][assetClassRiskName] === undefined) {
				fallback = true
			}
			let bid_data_forex = parseFloat(fallback ?
				updateData.bidRate :
				updateData[quoteAssetClass][assetClassRiskName].bidRate)
			let ask_data_forex = parseFloat(fallback ?
				updateData.askRate :
				updateData[quoteAssetClass][assetClassRiskName].askRate)
			let rates = {
				[key]: updateData.rate
			}
			newDataRates = {...newDataRates, ...rates}
			let current = latestRatesBidAsk?.[key]
			if (current) {
				newDataBidAsk[key] = {
					ask: +ask_data_forex,
					askUp: (+current.ask === +ask_data_forex)
						? undefined
						: (+current.ask < +ask_data_forex),
					bid: +bid_data_forex,
					bidUp: (+current.bid === +bid_data_forex)
						? undefined
						: (+current.bid < +bid_data_forex)
				}
			}
		}
		dispatch ({
			payload: {newDataBidAsk, newDataRates},
			type: ASSETS_UPDATE_BY_SOCKETS
		})
		dispatch(setNewDataPositions(newDataBidAsk, alert, t))
	}
}

export const setAssetSingle = (data) => {
	return {
		payload: data,
		type: ASSET_SET_SINGLE
	}
}

export const setAssetSearch = (data) => {
	return {
		payload: data,
		type: ASSET_SET_SEARCH
	}
}

export const setLatestRatesItem = (data) => {
	return {
		payload: data,
		type: LATEST_RATES_ITEM_SET
	}
}

export const getLotSizes = () => {
	return async dispatch => {
		try {
			const res = await api.assets.getLotSizesApi()
			if (res.data) {
				dispatch({
					payload: res.data,
					type: LOT_SIZES_GET
				})
			}
			return res.data
		} catch (e) {
			const error = executeResponseError(e, 'Getting lot seizes error')
			throw new Error(error || '')
		}
	}
}

export const getTradeSizes = () => {
	return async dispatch => {
		try {
			const res = await api.assets.getTradeSizesApi()
			if (res.data) {
				dispatch({
					payload: res.data,
					type: TRADE_SIZES_GET

				})
			}
			return res.data
		} catch (e) {
			const error = executeResponseError(e, 'Getting trade seizes error')
			throw new Error(error || '')
		}
	}
}

export const updateDataSizeTradeLot = (isPending, token) => {
	return async (dispatch, getState) => {
		const apiVersion = getState().appReducer.user?.userJson?.platform?.trading?.version
		try {
			const resTrade = await api.assets.getTradeSizesApi()
			const resLot= await api.assets.getLotSizesApi()
			if (resTrade.data && resLot.data) {
				dispatch({
					payload: resLot.data,
					resTrade: resTrade.data,
					type: UPDATE_TRADE_LOT_SIZES
				})
			}
			if (isPending) {
				const res = await api.user.getUserApi(token, apiVersion)
				await localStorage.removeItem('newUserData')
				localStorage.setItem('newUserData', JSON.stringify(res))
				// if (res?.data) dispatch(setUser(res.data))
			}
			return {
				lot: resLot.data,
				trade: resTrade.data
			}
		} catch (e) {
			const error = executeResponseError(e, 'Getting trade seizes error')
			throw new Error(error || '')
		}
	}
}
